import { Address } from 'models/Address/address.model';
import { serializable, object, alias, list } from 'serializr';

export class CategoryItem {
  @serializable
  id?: number;

  @serializable(alias('unique_index'))
  uniqueId?: number;

  @serializable
  name?: string | null = null;

  @serializable
  origin?: string;

  @serializable(alias('purchased_good_or_service_id'))
  purchasedGoodOrServiceId?: number;

  @serializable(alias('owned_vehicle_percentage'))
  ownedVehiclePercentage?: number;

  @serializable(alias('is_completely_owned_by_company'))
  isCompletelyOwnedByCompany?: boolean;

  @serializable(alias('temperature_control'))
  temperatureControl?: string | null = null;

  @serializable(alias('supplier_id'))
  supplierId?: number;

  @serializable(alias('is_transported_by_air'))
  isTransportedByAir?: boolean | null = null;

  @serializable
  quantity?: number | null = null;

  @serializable
  unit?: string | null = null;

  @serializable(alias('company_payment_percentage'))
  companyPaymentPercentage?: number | null = null;

  @serializable(alias('is_completely_paid_by_company'))
  isCompletelyPaidByCompany?: boolean = false;

  @serializable(alias('transportation_cost'))
  transportationCost?: number;

  @serializable(alias('mode_of_transportation'))
  modeOfTransportation?: string;

  @serializable(object(Address))
  address?: Address;

  addressLabel?: string | null = null;
}

export class FinishedGoods {
  @serializable(alias('total_weight'))
  totalWeight?: number;

  @serializable(alias('weight_transported'))
  weightTransported?: number;

  @serializable(alias('weight_in_storage'))
  weightInStorage?: number;

  @serializable(alias('weight_sold_via_online'))
  weightSoldViaOnline?: number;

  @serializable(list(object(CategoryItem)))
  products?: CategoryItem[] = [];
}
